export const Grain = () => (
  <div
    aria-hidden
    className="pointer-events-none fixed inset-0 z-[70] opacity-[0.045] mix-blend-multiply"
    style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='240'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
    }}
  />
);

export const Stamp = ({ className = "", small = false, testId }) => (
  <div
    data-testid={testId}
    className={`${small ? "" : "animate-stamp"} pointer-events-none select-none rounded-full border-[3px] border-[#C93B2B]/90 text-[#C93B2B] flex flex-col items-center justify-center text-center ${className}`}
    style={{ boxShadow: "inset 0 0 0 2px rgba(201,59,43,0.3)", transform: "rotate(8deg)" }}
  >
    <span className={`font-display italic leading-tight ${small ? "text-xs" : "text-sm sm:text-base"}`}>
      Necessaria iscrizione
    </span>
    <span className={`font-display italic leading-tight ${small ? "text-[10px]" : "text-xs sm:text-sm"}`}>
      Posti limitati
    </span>
  </div>
);

export const WaveBand = ({ className = "", tone = "navy" }) => {
  const c1 = tone === "navy" ? "#0C1B33" : "#0D9488";
  const c2 = tone === "navy" ? "rgba(12,27,51,0.35)" : "rgba(13,148,136,0.3)";
  const path =
    "M0 64 C 120 20, 240 108, 360 64 S 600 20, 720 64 S 960 108, 1080 64 S 1320 20, 1440 64 L1440 160 L0 160 Z";
  return (
    <div aria-hidden className={`overflow-hidden ${className}`}>
      <div className="relative h-full w-[200%]">
        <svg viewBox="0 0 1440 160" preserveAspectRatio="none" className="absolute inset-y-0 left-0 h-full w-1/2 animate-wave-slow" style={{ width: "100%" }}>
          <path d={path} fill={c1} />
        </svg>
        <svg viewBox="0 0 1440 160" preserveAspectRatio="none" className="absolute inset-y-0 left-0 h-full animate-wave-slower" style={{ width: "100%" }}>
          <path d={path} fill={c2} transform="translate(60,18)" />
        </svg>
      </div>
    </div>
  );
};

export const Gull = ({ className = "" }) => (
  <svg viewBox="0 0 48 20" className={className} fill="none" aria-hidden>
    <path
      d="M2 12 C 8 4, 14 4, 24 10 C 34 4, 40 4, 46 12"
      stroke="#0C1B33"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);

export const SwissFlag = ({ className = "h-3.5 w-3.5" }) => (
  <svg viewBox="0 0 20 20" className={`${className} rounded-[3px] shadow-sm`} aria-hidden>
    <rect width="20" height="20" rx="3" fill="#DA291C" />
    <rect x="8.4" y="4" width="3.2" height="12" fill="#fff" />
    <rect x="4" y="8.4" width="12" height="3.2" fill="#fff" />
  </svg>
);

export const PipitoneButton = ({ testId, compact = false }) => (
  <a
    data-testid={testId}
    href="https://pipitone.ch"
    target="_blank"
    rel="noopener noreferrer"
    className={`group inline-flex items-center gap-2 rounded-full border-2 border-[#0C1B33] bg-[#FFFDF9] font-semibold text-[#0C1B33] transition-[transform,background-color,color,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-[#0C1B33] hover:text-white hover:shadow-[0_10px_26px_rgba(12,27,51,0.28)] ${
      compact ? "px-3 py-1.5 text-xs sm:px-4 sm:py-2 sm:text-sm" : "w-full justify-center px-7 py-3.5 text-sm sm:w-auto"
    }`}
  >
    <span className={compact ? "hidden font-display tracking-tight min-[380px]:inline" : "font-display tracking-tight"}>pipitone.ch</span>
    <SwissFlag className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />
  </a>
);
